import { render } from "./TemplateAssetsView.vue?vue&type=template&id=04e78740&scoped=true"
import script from "./TemplateAssetsView.vue?vue&type=script&lang=js"
export * from "./TemplateAssetsView.vue?vue&type=script&lang=js"

import "./TemplateAssetsView.vue?vue&type=style&index=0&id=04e78740&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e78740"]])

export default __exports__